import { ChangeDetectionStrategy, Component, HostListener, OnInit, Renderer2 } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'

import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { RegisterBeatmakerAccountService } from '../../../services/register-beatmaker-account.service'
import { StartSellingService } from '../../../services/start-selling.service'

@Component({
  selector: 'bmcore-start-selling-popup',
  templateUrl: './bmcore-start-selling-popup.component.html',
  styleUrls: ['./bmcore-start-selling-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreStartSellingPopupComponent implements OnInit {
  lg: LgType
  isPopupOpen = false
  createBeatmakerAccountForm: UntypedFormGroup

  constructor(
    private renderer: Renderer2,
    private startSellingService: StartSellingService,
    private formBuilder: UntypedFormBuilder,
    private notificationService: NotificationService,
    private registerBeatmakerAccountService: RegisterBeatmakerAccountService,
    private router: Router,
    private authService: AuthService,
    private i18nService: I18nService
  ) {}

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closePopup()
    }
  }

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.createBeatmakerAccountForm = this.formBuilder.group({
      nickname: [],
      acceptTerms: [false, Validators.requiredTrue]
    })

    this.startSellingService.showStartSellingPopup.subscribe(() => {
      // No parent scroll on modal scroll
      this.renderer.addClass(document.body, 'modal-open')
      this.isPopupOpen = true
    })
  }

  closePopup() {
    this.isPopupOpen = false
    this.renderer.removeClass(document.body, 'modal-open')
  }

  onSubmit() {
    if (this.createBeatmakerAccountForm.valid) {
      const { nickname } = this.createBeatmakerAccountForm.value

      this.registerBeatmakerAccountService.createAccount(nickname.nickname).subscribe(
        res => {
          if (res.resultCode === ResultCode.Success) {
            this.router.navigate(['/subscriptions'])
            this.closePopup()
            this.authService.me()
          } else {
            this.notificationService.handleError(res.messages[0])
          }
        },
        err => this.notificationService.handleError(err.message)
      )
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
